import Repository from './Repository'
import { options } from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.pcmApi}/`
const resourceCrm = `${options.baseURL}/`

export default {
  async create(params) {
    const response = await Repository.post(`${resource}products`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async list(params) {
    const response = await Repository.get(`${resource}products`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getDetail(id) {
    const response = await Repository.get(`${resource}products/${id}`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getProductAttributes(params) {
    const response = await Repository.get(`${resource}product-attributes`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getCategories(params) {
    const response = await Repository.get(`${resource}category`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async basicSearchForCombo(params) {
    const response = await Repository.get(`${resource}skus/basic-search-for-combo`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async advanceSearchForCombo(params) {
    const response = await Repository.get(`${resource}skus`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getCurriculumAttributes(params) {
    const response = await Repository.get(`${resourceCrm}fg/list-data?obj=program&filters[$eq__status]=1&attrs[]=id&attrs[]=title&attrs[]=subject_id`, {
      params,
      headers: TokenService.getHeaderCrm(),
    })
    return response
  },

  async updateSkucombo(id, params) {
    const response = await Repository.put(`${resource}skus/${id}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async createSkucombo(id, params) {
    const response = await Repository.post(`${resource}skus`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async update(id, params) {
    const response = await Repository.put(`${resource}products/${id}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async updateSku(id, data) {
    const response = await Repository.put(`${resource}skus/${id}`, data, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async createSku(data) {
    const response = await Repository.post(`${resource}skus`, data, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async exportInvalidCombos(params) {
    const response = await Repository.get(`${resource}skus/export-invalid-combos`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getSkuPricePolicies(params) {
    const response = await Repository.get(`${resource}sku-price-policies`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async createPolicy(data) {
    const response = await Repository.post(`${resource}sku-price-policies`, data, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async updatePolicy(id, params) {
    const response = await Repository.put(`${resource}sku-price-policies/${id}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async updateStatusPolicy(id, params) {
    const response = await Repository.patch(`${resource}sku-price-policies/${id}/status`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getCrmProductGroupCodes() {
    const response = await Repository.get(`${resourceCrm}product-group?limit=100000&page=0&status=active`, {
      params: {},
      headers: TokenService.getHeader(),
    })
    return response
  },
}
